/**
 * Textos do `Paginator` (pt-BR). `{first}`, `{last}` e `{totalRecords}` são substituídos pelo `Paginator` do Prime.
 * O relatório é o texto que as telas já mostram (roles, audit, permissions, profissionais...): a Fase 5 não muda o texto.
 * A ficha do Figma (Paginator) não define o texto do relatório, só a posição.
 */
export const PAGINATOR_REPORT = "Mostrando {first} a {last} de {totalRecords} registros";
export const PAGINATOR_LABEL = "Paginação";
/** Rótulo do seletor de linhas (o Prime só traduz first/prev/next/last, pelo locale global). */
export const PAGINATOR_ROWS_LABEL = "Linhas por página";

/** Sufixo de cada opção do seletor: "10 por página". */
export const PAGINATOR_ROWS_SUFFIX = " por página";
